






















































import Vue from 'vue';
import api from '@/common/api';
import { JsonApiArrayResponse } from '@/jsonApi.types';
import PageLoader from '@/common/components/PageLoader.vue';
import { HelpfulVideo, initHelpfulVideo } from '@/common/components/support/support.types';
import videoEmbedPlayer from './videoEmbedPlayer.vue';

export default Vue.extend({
  created() {
    if (this.title) {
      document.title = this.title;
    }
  },
  data() {
    return {
      title: 'Helpful Videos' as string,
      helfulVideos: [] as any[],
      videoCategories: [] as any[],
      videoModal: false as boolean,
      newHelpfulVideo: initHelpfulVideo() as HelpfulVideo,
    };
  },
  mounted() {
    this.loadHelpfulVideos();
  },
  methods: {
    play(video: HelpfulVideo) {
      this.videoModal = true;
      this.newHelpfulVideo = video;
    },
    closeVideoModal() {
      this.newHelpfulVideo = initHelpfulVideo();
      this.videoModal = false;
    },
    loadHelpfulVideos() {
      if (this.$refs.loader) {
        (this.$refs.loader as any).setLoading();
      }
      api.get('helpful-videos')
        .then(this.setHelpfulVideos)
        .catch(this.handleLoadingError);
    },
    handleLoadingError() {
      this.$toasted.error('Helpful Videos are not found');
    },
    setHelpfulVideos({ data }: { data: JsonApiArrayResponse<any> }) {
      const videos = data.data!;
      // const a:any[] = [];
      Object.keys(videos).forEach((key: any) => {
        const video = videos[key];
        if (!this.videoCategories.includes(video.category)) {
          this.videoCategories.push(video.category);
          this.helfulVideos[video.category] = [];
        }

        this.helfulVideos[video.category].push(video);
      });

      if (this.$refs.loader) {
        (this.$refs.loader as any).setReady();
      }
    },
  },
  components: {
    PageLoader,
    videoEmbedPlayer,
  },
});

